/**
 * @generated SignedSource<<dd9a1f1431b3d01e64284eeee856bc0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeRuleSetCommunity_meter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradePointId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlatPricingForm_meter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeOfUsePricingForm_meter"
    }
  ],
  "type": "Meter",
  "abstractKey": null
};

node.hash = "90aac19d99ab5941f51a84bc571e5e58";

module.exports = node;
